(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-slider-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('#benefit-slider', {
      type       : 'loop',
      autoWidth: true,
      drag: false,
      arrows     : false,
      pagination : false,
      focus      : 'center',
      gap        : '80px',
      perPage    : 4,
      autoScroll : {
        speed : 0.5,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        1440: { perPage: 3 },
        1023 : { perPage: 2 },
        480 : { perPage: 1, gap  : '2rem', },
      },
    }).mount(window.splide.Extensions);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cf-dp-faq-section .faq-item').forEach(item => {
  const iconSpan = item.querySelector('.plus-icon');
  const plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" height="25" width="24"><path stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="#121212" d="M12 8.87207V16.8721M8 12.8721H16M22 12.8721C22 18.3949 17.5228 22.8721 12 22.8721C6.47715 22.8721 2 18.3949 2 12.8721C2 7.34922 6.47715 2.87207 12 2.87207C17.5228 2.87207 22 7.34922 22 12.8721Z"></path></svg>`;
  const minusIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" height="25" width="24"><path stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="#121212" d="M8 12.8721H16M22 12.8721C22 18.3949 17.5228 22.8721 12 22.8721C6.47715 22.8721 2 18.3949 2 12.8721C2 7.34922 6.47715 2.87207 12 2.87207C17.5228 2.87207 22 7.34922 22 12.8721Z"></path></svg>`;

  item.addEventListener('click', () => {
    const isActive = item.classList.contains('active');

    document.querySelectorAll('.cf-dp-faq-section .faq-item').forEach(i => {
      i.classList.remove('active');
      i.querySelector('.plus-icon').innerHTML = plusIcon;
    });

    if (!isActive) {
      item.classList.add('active');
      iconSpan.innerHTML = minusIcon;
    } else {
      iconSpan.innerHTML = plusIcon;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-section"] && !Shopify.designMode) return;
  try {
    

    document.querySelector('.supplement-btn').onclick = () => {
        document.querySelector('.cf-dp-js-modal-overlay').classList.add('overlay-open');
        document.querySelector('.cf-dp-js-modal').classList.add('modal-open');
        document.querySelector('body').classList.add('overflow-hidden')
    };
    document.querySelector('.js-modal-close').onclick = () => {
        document.querySelector('.cf-dp-js-modal-overlay').classList.remove('overlay-open');
        document.querySelector('.cf-dp-js-modal').classList.remove('modal-open');
        document.querySelector('body').classList.remove('overflow-hidden')
    };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('#review-slider', {
      type: 'loop',
      perPage: 1,
      gap: '3rem',
      arrows: true,
      autoplay: true,
      speed: 1000,
      pagination: false,
      // autoplay: true
      breakpoints: {
        767: {
        arrows: false,
        pagination: true,
      }
    },
    }).mount();
  });

  } catch(e) { console.error(e); }
})();
})();
